import React, { useEffect, useRef, useState } from 'react';
import { getImages, getNodeIdFromPath, getProducttypes, updateImage } from '../api';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';
import {
    Stack,
    Text,
    PrimaryButton,
    Image,
    Spinner,
    MessageBar,
    MessageBarType,
    Panel,
    PanelType,
    Label,
    DefaultButton
} from '@fluentui/react';
import { IProducttype, IProgram } from './DataTable';
import { Alert } from '@mui/material';

export default function ManageImagesPanel(props: { program: IProgram; onDismiss: () => void; }): JSX.Element {
    const { instance, accounts } = useMsal();

    const [token, setToken] = useState<string>("");
    const [images, setImages] = useState<string[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [selectedImage, setSelectedImage] = useState<string | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [warningMessage, setWarningMessage] = useState<string | null>(null);
    const [successMessage, setSuccessMessage] = useState<string | null>(null);
    const [productType, setProductType] = useState<IProducttype | null>(null);
    //const fileInputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        setIsLoading(true);
        instance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0],
        }).then(async (response) => {
            setToken(response.accessToken);
            getImages(response.accessToken).then((response) => {
                if (response && response.data) {
                    const data: any[] = response.data;
                    setImages(data);
                    setIsLoading(false);
                }
            })
            getProducttypes(response.accessToken).then((response) => {
                if (response && response.data) {
                    const data: IProducttype[] = response.data;
                    const productType = data.find((productType) => productType.produkttypeID === props.program.produkttypeID);
                    setProductType(productType);
                }
            })
        });
    }, [accounts, instance]);

    // const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    //     const file = event.target.files?.[0];
    //     if (!file) return;

    //     try {
    //         const img = document.createElement('img');
    //         const objectURL = URL.createObjectURL(file);

    //         img.onload = async () => {
    //             if (img.width === 2000 && img.height === 540) {
    //                 const newFileName = file.name.replace(/\.[^/.]+$/, "");
    //                 const renamedFile = new File([file], newFileName, { type: file.type });

    //                 const imageUrl = await uploadImage(token, renamedFile);
    //                 console.log("Uploaded image", images);
    //                 if (imageUrl && imageUrl.data.imageUrl === 'string') {
    //                     setImages([...images, imageUrl.data.imageUrl]);
    //                 } else {
    //                     console.error("Fejl ved upload af billede", imageUrl);
    //                     setError("Kunne ikke uploade billede.");
    //                 } setError(null);
    //             } else {
    //                 setError("Billedet skal være 2000x540 pixels.");
    //             }
    //             URL.revokeObjectURL(objectURL);
    //         };

    //         img.onerror = () => {
    //             setError("Kunne ikke læse billedet. Prøv igen.");
    //         };

    //         img.src = objectURL;
    //     } catch (err) {
    //         console.error("Fejl ved upload af billede", err);
    //         setError("Kunne ikke uploade billede.");
    //     }
    // };

    const getMediaPath = (url) => {
        try {
            const urlObj = new URL(url);

            // Fjern container-navnet (første segment), så stien matcher Umbracos media-sti (/media/...)
            // uanset hvad blob-containeren hedder.
            const path = decodeURIComponent(urlObj.pathname);

            return path.replace(/^\/[^/]+/, "");
        } catch (error) {
            console.error("Invalid URL:", error);
            return null;
        }
    };

    const onSaveImage = async () => {
        if (!selectedImage) {
            setWarningMessage("Vælg et billede først.");
            return;
        }
        try {
            const relativePath = getMediaPath(selectedImage);
            const fileName = relativePath.split("/").pop();
            await getNodeIdFromPath(token, relativePath).then(async (response) => {
                if (response && response.data) {
                    const nodeId = response.data;
                    console.log("Node ID", response);
                    const coursePath = `/kurser/${productType.navn}/${props.program.navn.replace(/ /g, "-")}`;
                    const productTypeName = productType.navn.replace(/ /g, "-");

                    await updateImage(token, coursePath, props.program.navn, productTypeName, nodeId, fileName).then((updateResponse) => {
                        if (updateResponse && updateResponse.status === 200) {
                            setSuccessMessage("Billedet blev opdateret succesfuldt.");
                        } else {
                            setWarningMessage("Kunne ikke opdatere billedet.");
                        }
                    }).catch((error) => {
                        console.error("Fejl ved opdatering af billede", error);
                        setWarningMessage("Kunne ikke opdatere billedet.");
                    });
                }
                else {
                    console.log("Fejl ved hentning af node ID", response);
                    setWarningMessage(`Billedet blev ikke fundet i Umbraco (${relativePath}).`);
                }
            }).catch((error) => {
                console.error("Fejl ved hentning af node ID", error);
                setWarningMessage("Kunne ikke hente node ID.");
            });

        } catch (error) {
            console.error("Fejl ved upload af billede", error);
            setError("Kunne ikke uploade billede.");

        }

    };



    return (
        <Panel
            type={PanelType.largeFixed}
            isOpen={props !== null}
            onDismiss={() => props.onDismiss()}
            closeButtonAriaLabel="Close"
            className="ContentPanel"
            styles={{
                content: {
                    display: "flex",
                    flexDirection: "column",
                    flexGrow: 1,
                    minHeight: 0,
                },
                scrollableContent: {
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    minHeight: 0,
                    overflowY: "auto",
                    height: "100%",
                    marginBottom: "325px",
                },
            }}
        >
            <div
                style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 100,
                    backgroundColor: "white",
                    paddingBottom: "1rem",
                    marginTop: "-18px",
                    paddingTop: "1rem",
                    width: "90%",
                }}
            >
                <h4 style={{ margin: 0 }}>{props?.program.navn}</h4>
                <p>Administrer billede</p>
            </div>

            {isLoading ? <Spinner label="Henter billeder..." /> : null}

            <div>
                <Stack horizontal wrap tokens={{ childrenGap: 10 }}>
                    {images.map((image, index) => (
                        <Stack key={index} onClick={() => setSelectedImage(image)} styles={{ root: { cursor: 'pointer', width: "50%", margin: 0, padding: 5 } }}>
                            <Image
                                src={image}
                                width="100%"
                                height="auto"
                                styles={{ root: { border: selectedImage === image ? '3px solid blue' : '1px solid gray' } }}
                            />
                        </Stack>
                    ))}
                </Stack>
            </div>
            <div className="btnSaveContainer">
                {warningMessage && (
                    <MessageBar messageBarType={MessageBarType.warning} onDismiss={() => setWarningMessage(null)}>
                        {warningMessage}
                    </MessageBar>
                )}

                {successMessage && (
                    <MessageBar messageBarType={MessageBarType.success} onDismiss={() => setSuccessMessage(null)}>
                        {successMessage}
                    </MessageBar>
                )}
                {error && (
                    <MessageBar messageBarType={MessageBarType.error} isMultiline={false}>
                        {error}
                    </MessageBar>
                )}
                {/* <Stack tokens={{ childrenGap: 10 }}>
                    <input type="file" accept="image/*" ref={fileInputRef} onChange={handleFileChange} style={{ display: "none" }} />
                    <DefaultButton
                        text="Upload billede"
                        onClick={() => fileInputRef.current?.click()}
                    />
                </Stack> */}
                {selectedImage && (
                    <Stack>
                        <Label>Valgt billede:</Label>
                        <Image src={selectedImage} width={300} height="auto" />
                    </Stack>
                )}
                {!successMessage ? (
                    <PrimaryButton text="Vedhæft billede" className="btnSave" onClick={onSaveImage} />
                ) : (
                    <PrimaryButton
                        text="Luk"
                        className="btnSave"
                        onClick={() => props.onDismiss()}
                        styles={{ root: { backgroundColor: "#f3f3f3", color: "#000" } }}
                    />
                )}
            </div>
            {error && <Alert severity="warning">{error}</Alert>}
        </Panel>
    );
}
